import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-img-loader',
  templateUrl: './img-loader.component.html',
  styleUrls: ['./img-loader.component.scss']
})
export class ImgLoaderComponent implements OnInit {
  @Input() class: string = '';
  @Input() url: string = '';
  @Input() width: number = 0;
  @Input() height: number = 0;
  @Input() loading: boolean = true;
  backgroundColor: string = '';
  foregroundColor: string = '';
  constructor() {}

  ngOnInit(): void {}
  loaded(event: any) {
    this.loading = false;
  }
}
